<span class="status"
      [ngClass]="{ 'cursor-pointer': hasMessages(), 'status-created': !hasErrors(), 'status-failed': hasErrors()}"
      (click)="hasMessages() ? openInfo() : null"
>
  <span *ngIf="hasErrors()" translate>FAILED</span>
  <span *ngIf="!hasErrors()" translate>CREATED</span>
  <i *ngIf="hasMessages()" class="fas fa-info-circle ml-1"></i>
</span>
